"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingOverlay = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const native_1 = require("styled-components/native");
const atoms_1 = require("../../atoms");
const LoadingOverlay_styled_1 = require("./LoadingOverlay.styled");
exports.LoadingOverlay = ({ useNativeDriver, loadingText, overrideBackgroundColor, }) => {
    const theme = native_1.useTheme();
    // pass by value = temporary change
    if (overrideBackgroundColor) {
        theme.bpCore.colors.loadingOverlay.backgroundColor = overrideBackgroundColor;
    }
    return (react_1.default.createElement(LoadingOverlay_styled_1.LoadingOverlayContainer, { theme: theme },
        react_1.default.createElement(react_native_1.StatusBar, { translucent: true, backgroundColor: "transparent" }),
        react_1.default.createElement(atoms_1.LoadingIndicator, { spinningColor: theme.bpCore.colors.loadingOverlay.spinner.spinningColor, thickness: 3, size: 33, color: theme.bpCore.colors.loadingOverlay.spinner.color, useNativeDriver: useNativeDriver }),
        Boolean(loadingText) && (react_1.default.createElement(LoadingOverlay_styled_1.LoadingOverlayText, null, loadingText))));
};
